import type { Challenge } from '@/config/objects/challenges';
import { useOutletContext } from 'react-router-dom';

interface ChallengeContext {
  challenge: Challenge | undefined;
  isLoading: boolean;
}

export function useChallengeContext() {
  return useOutletContext<ChallengeContext>();
}
